import {useState} from 'react';

import {InputChangeEvent} from 'util/Types';

export interface ControlledInputProps {
  value: string;
  onChange: (e: InputChangeEvent) => void;
}

/**
 * Custom React hook to use with form input fields.
 *
 * See useFormInput.stories.tsx for example usage.
 */
export default function useFormInput(initialValue: string): ControlledInputProps {
  const [value, setValue] = useState(initialValue);
  return {
    value,
    onChange: (e: InputChangeEvent) => {
      setValue(e.target.value);
    },
  };
}
